import { IconButton } from "@mui/material";

const CustomButton = ({ actionToDo, isDisabled, className, icon, text }) => {

	return (
		<IconButton
			className={className}
			onClick={actionToDo}
			disabled={isDisabled}
		>
			{icon}  {text}
		</IconButton>


	);

};

export default CustomButton;